// removed by extract-text-webpack-plugin
module.exports = {"container":"container___2-o4T","title":"title___vNO0t","inputContainer":"inputContainer___1WyPq","btnContainer":"btnContainer___2zbEf","description":"description___GOemU","descriptionText":"descriptionText___3Doc-","successMsg":"successMsg___cFjQh","errorMsg":"errorMsg___9Sn7R"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/UserProfile/UserProfile.module.css
// module id = 413
// module chunks = 0